<template>
  <cx-showcase-section :name="name" :link="link">
    <div class="cxu-display-flex-column">
      <div class="cx-select-showcase cxu-d-flex cxu-gap-40">
        <n-cx-select
          :items="items.cxSelectDisabled"
          v-model:selectedItemIds="selectedItemIds.cxSelectDisabled"
          @update:selectedItemIds="onSelectionChanged"
          label="Disabled Select Menu"
          tooltip="Disabled Select Menu"
          activatorPlaceholder="Select item..."
          disabled/>
        <n-cx-select
          :items="items.cxSelectLoading"
          v-model:selectedItemIds="selectedItemIds.cxSelectLoading"
          @update:selectedItemIds="onSelectionChanged"
          label="Loading Select Menu"
          tooltip="Loading Select Menu"
          activatorPlaceholder="Select item..."
          loading/>
        <n-cx-select
          :items="items.cxSelectSingleSelect"
          v-model:selectedItemIds="selectedItemIds.cxSelectSingleSelect"
          @update:selectedItemIds="onSelectionChanged"
          label="Single Select Menu"
          tooltip="Single Select Menu"/>
        <n-cx-select
          :items="items.cxSelectMultiSelect"
          v-model:selectedItemIds="selectedItemIds.cxSelectMultiSelect"
          @update:selectedItemIds="onSelectionChanged"
          label="Multi Select Menu"
          tooltip="Multi Select Menu"
          multiselect/>
      </div>
      <div class="cx-select-showcase cxu-d-flex cxu-gap-40">
        <n-cx-select
          :items="items.cxSelectNoItems"
          v-model:selectedItemIds="selectedItemIds.cxSelectNoItems"
          @update:selectedItemIds="onSelectionChanged"
          label="Menu Default Placeholder"
          tooltip="Menu Default Placeholder"
          multiselect/>
        <n-cx-select
          :items="items.cxSelectNoItemsPlaceholder"
          v-model:selectedItemIds="selectedItemIds.cxSelectNoItemsPlaceholder"
          @update:selectedItemIds="onSelectionChanged"
          label="Menu Custom Placeholder"
          no-data-placeholder="Custom no data..."
          tooltip="Menu Custom Placeholder"/>
        <n-cx-select
          :items="items.cxSelectCustomActivator"
          v-model:selectedItemIds="selectedItemIds.cxSelectCustomActivator"
          @update:selectedItemIds="onSelectionChanged"
          label="Custom Activator"
          tooltip="Custom Activator">
          <template #activator>
            <div class="n-cx-select-custom-activator center-v">
              <cx-badge :text="cxSelectCustomActivatorText" icon="arrow_drop_down" :iconSize="17" tooltip="Custom Activator"/>
            </div>
          </template>
        </n-cx-select>
        <n-cx-select
          menuItemClassName="n-cx-select-custom-menu-item"
          :items="items.cxSelectCustomMenuItem"
          v-model:selectedItemIds="selectedItemIds.cxSelectCustomMenuItem"
          @update:selectedItemIds="onSelectionChanged"
          label="Custom Menu Item"
          activatorPlaceholder=""
          tooltip="Custom Menu Item">
          <template #menu-item="props">
            <div class="n-cx-select-custom-menu-item">
              <img class="n-cx-select-custom-menu-item__image" :src="props.item.img"/>
              <div class="n-cx-select-custom-menu-item__text">
                <span class="n-cx-select-custom-menu-item__text__title">{{ props.item.title }}</span>
                <span class="n-cx-select-custom-menu-item__text__subtitle">{{ props.item.subtitle }}</span>
              </div>
            </div>
          </template>
        </n-cx-select>
        <n-cx-select
          class="n-cx-select--populous"
          :items="items.cxSelectMultiSelectPopulous"
          v-model:selectedItemIds="selectedItemIds.cxSelectMultiSelectPopulous"
          @update:selectedItemIds="onSelectionChanged"
          label="Very Populous Select Menu"
          tooltip="Very Populous Select Menu"
          multiselect/>
        <n-cx-select
          :items="items.cxSelectSingleSelect"
          v-model:selectedItemIds="selectedItemIds.cxSelectSingleSelect"
          @update:selectedItemIds="onSelectionChanged"
          label="Some Label"
          tooltip="Single Select Menu">
          <template #label>
            <div class="n-cx-select-custom-label">
              <span>Custom Label</span>
            </div>
          </template>
        </n-cx-select>
      </div>
    </div>
  </cx-showcase-section>
</template>

<script>
import CxShowcaseSection from '@/components/showcase/CxShowcaseSection';
import NCxSelect from '@/components/NCxSelect';
import CxBadge from '@/components/CxBadge';

export default {
  name: 'CxSelectShowcase',
  components: {
    CxShowcaseSection,
    NCxSelect,
    CxBadge
  },
  data() {
    return {
      name: 'NCxSelect',
      link: 'https://miro.com/app/board/o9J_lDPoVY8=/?moveToWidget=3074457359436791991&cot=14',
      items: {
        cxSelectDisabled: [],
        cxSelectLoading: [],
        cxSelectSingleSelect: [
          { id: 1, title: 'Item 1', subtitle: 'subtitle 1' },
          { id: 2, title: 'Item 2' },
          { id: 3, title: 'Item 3' },
        ],
        cxSelectMultiSelect: [
          { id: 1, title: 'Item 1', subtitle: 'subtitle 1' },
          { id: 2, title: 'Item 2', subtitle: 'subtitle 2' },
          { id: 3, title: 'Item 3' },
        ],
        cxSelectNoItems: [],
        cxSelectNoItemsPlaceholder: [],
        cxSelectCustomActivator: [
          { id: 1, title: 'Item 1' },
          { id: 2, title: 'Item 2' },
          { id: 3, title: 'Item 3' }
        ],
        cxSelectCustomMenuItem: [
          { id: 1, title: 'Item 1', subtitle: 'subtitle 1', img: 'http://www.randomkittengenerator.com/cats/101900.2.jpg' },
          { id: 2, title: 'Item 2', subtitle: 'subtitle 2', img: 'http://www.randomkittengenerator.com/cats/18356.jpg' },
          { id: 3, title: 'Item 3', subtitle: 'subtitle 3', img: 'http://www.randomkittengenerator.com/cats/85835.2.jpg' }
        ],
        cxSelectMultiSelectPopulous: [
          { id: 1, title: 'Item 1' },
          { id: 2, title: 'Item 2' },
          { id: 3, title: 'Item 3 with a very long name' },
          { id: 4, title: 'Item 4' },
          { id: 5, title: 'Item 5' },
          { id: 6, title: 'Item 6' },
          { id: 7, title: 'Item 7' },
          { id: 8, title: 'Item 8' },
          { id: 9, title: 'Item 9' },
          { id: 10, title: 'Item 10' },
          { id: 11, title: 'Item 11' },
          { id: 12, title: 'Item 12' },
          { id: 13, title: 'Item 13' },
          { id: 14, title: 'Item 14' },
          { id: 15, title: 'Item 15' },
          { id: 16, title: 'Item 16' },
          { id: 17, title: 'Item 17' },
          { id: 18, title: 'Item 18' },
          { id: 19, title: 'Item 19' },
          { id: 20, title: 'Item 20' },
          { id: 21, title: 'Item 21' },
          { id: 22, title: 'Item 22' },
          { id: 23, title: 'Item 23' },
          { id: 24, title: 'Item 24' },
          { id: 25, title: 'Item 25' },
          { id: 26, title: 'Item 26' },
          { id: 27, title: 'Item 27' },
          { id: 28, title: 'Item 28' },
          { id: 29, title: 'Item 29' },
          { id: 30, title: 'Item 30' },
          { id: 31, title: 'Item 31' },
          { id: 32, title: 'Item 32' }
        ]
      },
      selectedItemIds: {
        cxSelectDisabled: [],
        cxSelectLoading: [],
        cxSelectSingleSelect: [],
        cxSelectMultiSelect: [],
        cxSelectNoItems: [],
        cxSelectNoItemsPlaceholder: [],
        cxSelectCustomActivator: [],
        cxSelectCustomMenuItem: [],
        cxSelectMultiSelectPopulous: []
      }
    };
  },
  computed: {
    cxSelectCustomActivatorText() {
      const [selectedItemId] = this.selectedItemIds.cxSelectCustomActivator;
      const selectedItem = this.items.cxSelectCustomActivator.find(i => i.id === selectedItemId);
      return selectedItem ? selectedItem.title : 'Select item...';
    }
  },
  methods: {
    onSelectionChanged(data) {
      // eslint-disable-next-line no-console
      console.log('list selection changed: ', data);
    }
  },
};
</script>

<style lang="less">
@import '../../common';

.cx-select-showcase {
   width: 100%;
  margin-bottom: 15px;

  .cx-select-menu-item {
    display: flex;
    flex-direction: column;
    padding: 0 5px;
    .cut-overflow();
    cursor: pointer;

    .cx-select-menu-item__title {
      color: @textColor;
      .cut-overflow();
    }

    .cx-select-menu-item__subtitle {
      color: @textColorDisabled;
      font-size: 10px;
    }
  }

  .n-cx-select-custom-activator {
    background-color: @grayBtnColor;
    border-radius: 4px;
    width: 100%;
    height: @inputHeight;
    padding-left: 8px;

    .cx-badge {
      height: 100%;
    }

    .cx-badge__caption, i {
      color: @textColor;
    }
  }

  .n-cx-select-custom-menu-item {
    display: flex;
    align-items: center;
    height: 70px;

    .n-cx-select-custom-menu-item__image {
      display: block;
      height: 50px;
      width: 50px;
    }

    .n-cx-select-custom-menu-item__text {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left: 8px;

      .n-cx-select-custom-menu-item__text__subtitle {
        color: @textColorLowlight;
      }
    }
  }

  .n-cx-select--populous {
    width: 190px;
  }

  .n-cx-select-custom-label {
    font-weight: bold;
    color: white;
    text-align: center;
  }
}
</style>